import { Vacancy, getCapitalizedType } from "@/app/network/apis/vacancy-api";
import Link from "next/link";

interface JobCardProps {
  job: Vacancy;
}

// Legacy interface for backward compatibility
export interface JobListing {
  id: string;
  title: string;
  location: string;
  type: "On-site" | "Remote" | "Hybrid";
  city?: string;
  postedTime: string;
  urgency: string;
  description: string;
  employmentType: string;
  experience: string;
  category: string;
}

export function JobCard({ job }: JobCardProps) {
  const employmentType = getCapitalizedType(job);
  const locationText = job.location || "Remote";

  return (
    <Link
      href={`/careers/${job.uuid}`}
      className="group relative block h-full overflow-hidden rounded-xl border border-gray-300 bg-white p-6 transition-colors hover:border-gray-900/70 cursor-pointer"
    >
      <div className="flex flex-col gap-5">
        <div>
          <div className="flex items-center gap-3 mb-2">
            <h3 className="text-2xl font-semibold tracking-tight text-gray-900 group-hover:text-blue-600 transition-colors">{job.title}</h3>
            <div className="inline-flex items-center rounded-full bg-gray-800 px-3 py-1 text-xs font-medium text-white">
              <span className="truncate">{job.department}</span>
            </div>
          </div>
          <p className="text-lg leading-relaxed text-gray-600/90 line-clamp-2">{(job as any).short_description || job.description}</p>
        </div>

        <div className="flex flex-wrap gap-3">
          <div className="inline-flex items-center rounded-full bg-blue-50 border border-blue-200 px-3 py-1.5 text-sm font-medium text-blue-700">
            <span className="truncate">{locationText}</span>
          </div>
          <div className="inline-flex items-center rounded-full bg-green-50 border border-green-200 px-3 py-1.5 text-sm font-medium text-green-700">
            <span className="truncate">{employmentType}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}
